<ng-container *ngIf="platformBrowser">
  <router-outlet></router-outlet>

  <div
    class="view-gallery-page"
    [style.--gallery-background-color]="gallery.layout_background_color || 'white'"
    [class.dark]="darkGalleryBackground"
  >
    <app-view-gallery-header
      [gallery]="gallery"
      [accessLevel]="accessLevel"
      [mode]="'layout'"
      (onFilterChange)="onFilter($event)"
    ></app-view-gallery-header>

    <div class="header-gradient" *ngIf="gallery.cover.uuid && accessLevel !== 'view_only'"></div>

    <div
      class="cover-container"
      [class.has-asset]="gallery.cover.uuid"
      [style.--color-primary]="gallery.primary_color"
      *ngIf="gallery.cover.uuid || gallery.title || gallery.description"
    >
      <div
        class="cover size-{{ gallery.cover.uuid ? gallery.cover.size : 'none' }}"
        [class.content-left]="gallery.cover.content_position?.[0] === 0"
        [class.content-right]="gallery.cover.content_position?.[0] === 1"
        [class.content-top]="gallery.cover.content_position?.[1] === 0"
        [class.content-bottom]="gallery.cover.content_position?.[1] === 1"
      >
        <div class="cover-asset" *ngIf="gallery.cover?.uuid && platformBrowser" #el>
          <img
            [src]="
              gallery.cover?.uuid
                | galleryCoverUrl : gallery.cover.width : gallery.cover.height : el.clientWidth : el.clientHeight
                | async
            "
            alt=""
            onload="this.className='loaded'"
            [style.object-position]="gallery.cover.position"
          />
          <!-- <ng-container *ngIf="getVideoOrigin()">
            <app-video-viewer
              [videoData]="$any(gallery.cover)"
              [uuid]="getVideoUuid()"
              [origin]="getVideoOrigin()"
              [poster]="
                gallery.cover?.uuid
                  | galleryCoverUrl : gallery.cover.width : gallery.cover.height : el.clientWidth : el.clientHeight
                  | async
              "
              [active]="true"
              [showUi]="false"
              [autoPlay]="true"
              [muted]="true"
              [loop]="true"
              [cover]="true"
              [coverPosition]="gallery.cover.position"
              [targetWidth]="el.clientWidth"
            ></app-video-viewer>
          </ng-container> -->
        </div>
        <div class="cover-asset server-cover" *ngIf="gallery.cover?.uuid && !platformBrowser" #el></div>
        <div
          class="cover-overlay"
          *ngIf="gallery.cover?.uuid && platformBrowser"
          [style.backgroundColor]="gallery.cover?.overlay_color || 'transparent'"
        ></div>
        <div class="cover-content">
          <h1
            *ngIf="gallery.title"
            [style.color]="gallery.cover.title_typography?.font_color || gallery.default_title_typography?.font_color"
            [style.fontFamily]="
              (gallery.cover.title_typography?.font_family || gallery.default_title_typography?.font_family) +
              ', AkkuratLL'
            "
            class="{{ getFontSize(gallery.cover?.title_typography?.font_size) }}"
          >
            {{ gallery.title }}
          </h1>
          <h3
            *ngIf="gallery.description"
            [style.color]="
              gallery.cover.paragraph_typography?.font_color || gallery.default_paragraph_typography?.font_color
            "
            [style.fontFamily]="
              (gallery.cover.paragraph_typography?.font_family || gallery.default_paragraph_typography?.font_family) +
              ', AkkuratLL'
            "
            class="{{ getFontSize(gallery.cover?.paragraph_typography?.font_size) }}"
            [innerHTML]="gallery.description"
          ></h3>
        </div>
      </div>
    </div>

    <div *ngIf="!gallery.cover.uuid && !gallery.title && !gallery.description" class="no-cover-spacer"></div>

    <div #galleryBody class="content-container">
      <!-- <div class="gallery-menu" [class.dark]="darkGalleryBackground" *ngIf="platformBrowser">
        <a
          [routerLink]="['./advanced']"
          appButton
          name="advanced-mode"
          color="default-opacity"
          location="view-gallery-page"
          data-test-id="view-advanced-mode"
          [hasIcon]="true"
          weight="bold"
          *ngIf="allowAdvancedMode"
        >
          <app-svg src="/assets/icons/search-menu.svg"></app-svg>
          <span>{{ 'am-button' | translate }}</span>
        </a>

        <app-context-menu
          [options]="{ width: '240px', noSpacing: true }"
          #downloadMenu
          *ngIf="gallery.download_full_gallery"
        >
          <button
            appButton
            name="download-all"
            color="default-opacity"
            location="view-gallery-page"
            data-test-id="download-gallery"
            [hasIcon]="true"
            weight="bold"
            [hideTextOnMobile]="allowAdvancedMode"
            contextButton
          >
            <app-svg src="/assets/icons/download.svg"></app-svg>
            <span *ngIf="!downloadingAll && !preppingDownloadAll">{{ 'download-all-button' | translate }}</span>
            <span *ngIf="preppingDownloadAll">{{ 'download-all-button-clicked' | translate }}</span>
            <span *ngIf="downloadingAll">{{ 'download-all-button-downloading' | translate }}</span>
          </button>

          <div class="button-menu" contextContent>
            <app-gallery-download-menu-options
              [gallery]="gallery"
              [includeSubGalleries]="true"
              (onDownload)="download($event); downloadMenu.close()"
              *ngIf="downloadMenu.isOpen"
            >
            </app-gallery-download-menu-options>
          </div>
        </app-context-menu>

        <app-view-filter
          [gallery]="gallery"
          [accessLevel]="accessLevel"
          (onFilterChange)="onFilter($event)"
          *ngIf="accessLevel !== 'view_only' && !allowAdvancedMode"
          #viewFilter
        >
        </app-view-filter>
      </div> -->

      <div>
        <div *ngIf="noAssetsResult" class="no-results" [class.dark]="darkGalleryBackground">
          <h3>No assets found</h3>
          <button
            (click)="resetFilter()"
            appButton
            color="default-opacity"
            name="reset-view-search-filter"
            location="view-gallery-page"
            [center]="true"
          >
            Reset Filter
          </button>
        </div>

        <ng-container *ngFor="let section of sections | sortBy : 'position'; let i = index">
          <div class="page section-page" *ngIf="section.object === 'gallery' && !filters.length">
            <app-album-section [section]="toAlbumSection(section)" [parentGallery]="gallery"></app-album-section>
          </div>
          <div class="page full section-page text-section-page" *ngIf="section.object === 'text' && !filters.length">
            <app-text-section
              [section]="toTextSection(section)"
              [gallery]="gallery"
              [darkGalleryBackground]="darkGalleryBackground"
            ></app-text-section>
          </div>
          <app-assets-section
            [section]="toAssetSection(section)"
            [gallery]="gallery"
            [accessLevel]="accessLevel"
            *ngIf="section.object === 'asset' && section.position !== 612512"
            [filters]="filters"
            [darkGalleryBackground]="darkGalleryBackground"
          >
          </app-assets-section>
          <app-embed-section
            [section]="toEmbedSection(section)"
            [gallery]="gallery"
            *ngIf="section.object === 'embed' && !filters.length"
          >
          </app-embed-section>
        </ng-container>
      </div>
    </div>

    <div class="gallery-footer brand">
      <a [routerLink]="'/'" class="brand-name-link">
        <img [src]="tenant.logo_url" alt="" *ngIf="tenant.logo_url" class="brand-logo" />
        <div class="brand-name" *ngIf="!tenant.logo_url">{{ tenant.name }}</div>
      </a>

      <div class="socials">
        <a
          appButton
          name="website"
          location="view-gallery-page-footer"
          color="simple-opacity"
          [iconButton]="true"
          class="social"
          height="1"
          appTooltip="{{ niceSite(tenant.contacts.site) }}"
          rel="nofollow noreferrer noopener"
          [href]="tenant.contacts.site"
          target="_blank"
          *ngIf="tenant.contacts?.site"
        >
          <app-svg src="/assets/icons/globe.svg"></app-svg>
        </a>

        <a
          appButton
          name="phone"
          location="view-gallery-page-footer"
          color="simple-opacity"
          [iconButton]="true"
          class="social"
          height="1"
          appTooltip="{{ tenant.contacts.phone }}"
          rel="nofollow noreferrer noopener"
          [href]="'tel:' + tenant.contacts.phone"
          target="_blank"
          *ngIf="tenant.contacts.phone"
        >
          <app-svg src="/assets/icons/phone.svg"></app-svg>
        </a>

        <a
          appButton
          name="email"
          location="view-gallery-page-footer"
          color="simple-opacity"
          [iconButton]="true"
          class="social"
          height="1"
          appTooltip="{{ tenant.contacts.email }}"
          rel="nofollow noreferrer noopener"
          [href]="'mailto:' + tenant.contacts.email"
          target="_blank"
          *ngIf="tenant.contacts.email"
        >
          <app-svg src="/assets/icons/email.svg"></app-svg>
        </a>

        <a
          appButton
          name="facebook"
          location="view-gallery-page-footer"
          color="simple-opacity"
          [iconButton]="true"
          class="social"
          height="1"
          rel="nofollow noreferrer noopener"
          [href]="'https://www.facebook.com/' + tenant.socials.facebook"
          target="_blank"
          *ngIf="tenant.socials.facebook"
        >
          <app-svg src="/assets/icons/logo/facebook.svg"></app-svg>
        </a>

        <a
          appButton
          name="instagram"
          location="view-gallery-page-footer"
          color="simple-opacity"
          [iconButton]="true"
          class="social"
          height="1"
          rel="nofollow noreferrer noopener"
          [href]="'https://www.instagram.com/' + tenant.socials.instagram"
          target="_blank"
          *ngIf="tenant.socials.instagram"
        >
          <app-svg src="/assets/icons/logo/instagram.svg"></app-svg>
        </a>

        <a
          appButton
          name="pinterest"
          location="view-gallery-page-footer"
          color="simple-opacity"
          [iconButton]="true"
          class="social"
          height="1"
          rel="nofollow noreferrer noopener"
          [href]="'https://www.pinterest.com/' + tenant.socials.pinterest"
          target="_blank"
          *ngIf="tenant.socials.pinterest"
        >
          <app-svg src="/assets/icons/logo/pinterest.svg"></app-svg>
        </a>

        <a
          appButton
          name="twitter"
          location="view-gallery-page-footer"
          color="simple-opacity"
          [iconButton]="true"
          class="social"
          height="1"
          rel="nofollow noreferrer noopener"
          [href]="'https://twitter.com/' + tenant.socials.twitter"
          target="_blank"
          *ngIf="tenant.socials.twitter"
        >
          <app-svg src="/assets/icons/logo/twitter.svg"></app-svg>
        </a>
      </div>

      <app-made-with-picflow-button
        [tenantId]="tenant.id"
        [darkBackground]="darkGalleryBackground"
        *ngIf="!gallery || gallery['tenant'].picflow_branding_enabled"
      >
      </app-made-with-picflow-button>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!platformBrowser">
  <div class="page center tiny loading">
    <app-tenant-icon-loader [tenant]="tenant"></app-tenant-icon-loader>
  </div>
</ng-container>
